var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSleepActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 90,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 90,
    rx: 12,
    fill: "#14141D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51.822,
    cy: 11.298,
    r: 28.581,
    transform: "rotate(-84.255 51.822 11.298)",
    fill: "#181822"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.972,
    cy: 32.82,
    r: 21.941,
    transform: "rotate(-84.255 60.972 32.82)",
    fill: "#181822"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.027,
    cy: 98.435,
    r: 21.941,
    transform: "rotate(-84.255 18.027 98.435)",
    fill: "#181822"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.058,
    cy: 77.874,
    r: 11.548,
    transform: "rotate(-84.255 27.058 77.874)",
    fill: "#181822"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.646,
    cy: 33.648,
    r: 11.548,
    transform: "rotate(-84.255 3.646 33.648)",
    fill: "#1F1F2D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 67.646,
    cy: 81.535,
    r: 11.548,
    transform: "rotate(-84.255 67.646 81.535)",
    fill: "#272737"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.581,
    cy: 69.646,
    r: 11.548,
    transform: "rotate(-84.255 70.581 69.646)",
    fill: "#323246"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.344,
    cy: 64.271,
    r: 6.64,
    transform: "rotate(-84.255 4.344 64.271)",
    fill: "#181822"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.696,
    cy: 68.835,
    r: 4.042,
    transform: "rotate(-84.255 .696 68.835)",
    fill: "#1F1F2D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.706,
    cy: 23.713,
    r: 5.774,
    transform: "rotate(-84.255 8.706 23.713)",
    fill: "#1F1F2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.219 68.098c-.908-.653-.449-2.087.67-2.092l1.69-.007c.5-.002.942-.326 1.094-.802l.516-1.61c.34-1.065 1.846-1.071 2.196-.009l.529 1.605c.156.475.601.795 1.101.793l1.69-.007c1.119-.005 1.59 1.425.688 2.086l-1.363.999c-.403.296-.57.818-.414 1.293l.529 1.605c.35 1.062-.864 1.952-1.772 1.298l-1.37-.987a1.155 1.155 0 0 0-1.358.006l-1.363.998c-.902.662-2.124-.218-1.782-1.283l.515-1.61a1.155 1.155 0 0 0-.425-1.288l-1.371-.988Z",
    fill: "#1F1F2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.86 3.548c-.909-.654-.45-2.087.67-2.092l1.689-.007c.5-.002.942-.326 1.095-.803l.515-1.609c.341-1.065 1.846-1.071 2.197-.009l.529 1.605c.156.475.6.795 1.101.793l1.69-.007c1.119-.005 1.59 1.425.687 2.086l-1.362.999c-.404.296-.571.818-.414 1.293l.529 1.605c.35 1.062-.864 1.952-1.772 1.298l-1.371-.987a1.155 1.155 0 0 0-1.358.006l-1.362.998c-.903.662-2.124-.218-1.783-1.283l.515-1.61a1.155 1.155 0 0 0-.425-1.289l-1.37-.987ZM-2.229 19.05c-.907-.654-.448-2.087.67-2.092l1.69-.007c.5-.002.942-.326 1.095-.803l.515-1.609c.341-1.065 1.846-1.072 2.197-.009l.529 1.605c.156.475.601.795 1.101.793l1.69-.007c1.119-.005 1.59 1.425.688 2.086l-1.363.999c-.404.296-.57.818-.414 1.293l.529 1.605c.35 1.062-.864 1.952-1.772 1.298l-1.371-.987a1.155 1.155 0 0 0-1.358.006l-1.362.998c-.902.662-2.124-.218-1.783-1.283l.516-1.61a1.155 1.155 0 0 0-.425-1.289l-1.372-.987Z",
    fill: "#323246"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.984 34.723c-.136.733.323 1.344 1.123 1.492l5.614 1.042c.568.105 1.056-.23 1.161-.798.107-.575-.228-1.063-.796-1.168l-4.082-.758.022-.12 4.787-4.331c.959-.835 1.24-1.185 1.329-1.663.14-.756-.28-1.32-1.088-1.47l-5.211-.967c-.583-.109-1.06.213-1.17.803-.108.583.215 1.053.805 1.163l3.708.688-.022.12-4.874 4.346c-.965.826-1.217 1.143-1.306 1.621ZM26.846 39.491c.093.452.498.695.992.594l3.463-.714a.596.596 0 0 0 .48-.729.597.597 0 0 0-.73-.484l-2.518.52-.015-.075 1.733-3.602c.355-.702.435-.969.374-1.264-.096-.465-.47-.691-.967-.589l-3.214.663c-.36.074-.558.37-.483.734.074.36.369.553.733.478l2.287-.471.015.074-1.78 3.63c-.36.7-.431.94-.37 1.235ZM30.904 46.055c-.167.389.01.785.436.968l2.983 1.281c.302.13.614.006.744-.296a.548.548 0 0 0-.295-.748l-2.17-.932.028-.064 3.197-1.802c.637-.343.837-.502.946-.756.173-.401.01-.767-.419-.952l-2.768-1.189c-.31-.133-.615-.015-.75.3-.133.309-.013.61.3.745l1.97.846-.026.064-3.248 1.8c-.64.336-.819.48-.928.735ZM24.582 58.768c0-.153-.023-.29-.07-.41a.774.774 0 0 0-.246-.34 2.18 2.18 0 0 0-.51-.311 7.214 7.214 0 0 0-.85-.316 10.76 10.76 0 0 1-1.1-.422 4.524 4.524 0 0 1-.915-.545 2.454 2.454 0 0 1-.621-.733 2.019 2.019 0 0 1-.223-.966 2 2 0 0 1 .235-.967c.156-.293.375-.543.656-.75.281-.211.613-.373.996-.486.387-.114.81-.17 1.271-.17.63 0 1.178.113 1.647.34.469.226.832.536 1.09.931.262.395.392.846.392 1.354h-1.746c0-.25-.052-.47-.158-.657a1.07 1.07 0 0 0-.469-.45c-.207-.11-.468-.165-.785-.165-.304 0-.558.047-.761.14-.204.09-.356.214-.457.37a.909.909 0 0 0-.153.515c0 .145.035.276.106.393.074.117.183.227.328.328.144.102.322.197.533.287.21.09.455.178.732.264.465.14.873.299 1.225.475.355.175.652.373.89.591a2.2 2.2 0 0 1 .54.745c.12.277.181.591.181.943 0 .371-.072.703-.216.996a2.046 2.046 0 0 1-.627.744 2.95 2.95 0 0 1-.979.463 4.738 4.738 0 0 1-1.271.158c-.422 0-.838-.054-1.248-.164a3.793 3.793 0 0 1-1.12-.51 2.57 2.57 0 0 1-.797-.867c-.199-.351-.298-.767-.298-1.248h1.763c0 .266.041.49.123.674.082.183.198.332.346.445.152.113.332.196.54.246.21.051.44.077.69.077.305 0 .555-.043.75-.13a.925.925 0 0 0 .44-.357.934.934 0 0 0 .146-.515ZM29.453 52v9h-1.694v-9h1.693Zm4.552 9.117a3.54 3.54 0 0 1-1.324-.234c-.39-.16-.723-.381-.996-.662a2.942 2.942 0 0 1-.622-.979 3.295 3.295 0 0 1-.216-1.195v-.234c0-.481.068-.92.205-1.319a3.1 3.1 0 0 1 .586-1.037c.258-.293.57-.517.937-.674.367-.16.782-.24 1.242-.24.45 0 .848.074 1.196.223.347.148.638.359.873.632.238.274.418.602.539.985.12.379.181.8.181 1.265v.704h-5.039v-1.125h3.381v-.13c0-.234-.043-.443-.129-.626a.996.996 0 0 0-.375-.446c-.168-.109-.383-.164-.644-.164-.223 0-.414.05-.574.147-.16.097-.291.234-.393.41a2.234 2.234 0 0 0-.223.621c-.047.234-.07.492-.07.773v.235c0 .254.035.488.105.703.075.215.178.4.311.557.137.156.3.277.492.363.196.086.416.129.662.129.305 0 .588-.059.85-.176.266-.121.494-.303.685-.545l.82.89a2.493 2.493 0 0 1-.544.551c-.227.176-.5.32-.82.434-.32.11-.686.164-1.096.164Zm6.72 0a3.54 3.54 0 0 1-1.324-.234c-.39-.16-.722-.381-.996-.662a2.94 2.94 0 0 1-.621-.979 3.293 3.293 0 0 1-.217-1.195v-.234c0-.481.069-.92.205-1.319.137-.398.332-.744.586-1.037.258-.293.57-.517.938-.674.367-.16.78-.24 1.242-.24.45 0 .848.074 1.195.223.348.148.639.359.873.632.239.274.418.602.54.985.12.379.18.8.18 1.265v.704h-5.038v-1.125h3.38v-.13c0-.234-.042-.443-.128-.626a.995.995 0 0 0-.375-.446c-.168-.109-.383-.164-.645-.164-.222 0-.414.05-.574.147-.16.097-.29.234-.392.41a2.231 2.231 0 0 0-.223.621c-.047.234-.07.492-.07.773v.235c0 .254.035.488.105.703.074.215.178.4.31.557.137.156.301.277.493.363.195.086.416.129.662.129.305 0 .588-.059.85-.176.265-.121.494-.303.685-.545l.82.89a2.493 2.493 0 0 1-.545.551c-.226.176-.5.32-.82.434-.32.11-.685.164-1.096.164Zm5.49-5.238v7.559h-1.687V54.66h1.564l.123 1.219Zm4.014 1.88v.124c0 .46-.055.889-.164 1.283a3.202 3.202 0 0 1-.469 1.031 2.227 2.227 0 0 1-.773.68c-.305.16-.657.24-1.055.24-.387 0-.723-.078-1.008-.234a2.099 2.099 0 0 1-.72-.656 3.8 3.8 0 0 1-.463-.99 7.814 7.814 0 0 1-.27-1.208v-.322c.063-.46.153-.883.27-1.266.117-.386.271-.72.463-1.002.195-.285.433-.505.714-.662.286-.156.62-.234 1.002-.234.403 0 .756.076 1.06.229.31.152.567.37.774.656.211.285.37.625.475 1.02.11.394.164.831.164 1.312Zm-1.693.124v-.123c0-.27-.024-.518-.07-.744a1.93 1.93 0 0 0-.212-.604 1.024 1.024 0 0 0-.375-.398 1.01 1.01 0 0 0-.556-.147c-.23 0-.428.037-.592.111a.988.988 0 0 0-.393.323c-.101.14-.177.308-.228.504-.05.195-.082.416-.094.662v.814c.02.29.074.55.164.78.09.226.229.406.416.539.188.132.434.199.739.199.222 0 .41-.049.562-.147.152-.101.275-.24.37-.416a1.9 1.9 0 0 0 .204-.609 4.06 4.06 0 0 0 .065-.744Z",
    fill: "#F3A952"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 45,
    r: 40,
    fill: "url(#b)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 35.5 -34.6404 0 36 45)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3A952",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#362510",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 90,
    rx: 12,
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSleepActive);
export default __webpack_public_path__ + "static/media/sleepActive.56fc66f0d03bcfde1bd09d3acfc5e537.svg";
export { ForwardRef as ReactComponent };